import * as remx from 'remx';

const initialState = {
    delay: 3500,
    time: 6000,
    values: ['animated videos', 'whiteboard videos', 'presentations', 'screen recordings', 'video ads', 'media content', 'branded characters', 'GIFs' ],
    tabs: ['Animated Videos', 'Whiteboard Videos', 'Presentations', 'Screen Recordings', 'Video Ads', 'Media Content', 'Branded Characters', 'GIFs'  ],
    colors: ['#F4D4F2', '#6A85F7', '#A796E7', '#2F51E4', '#8ED7D8', '#4D1BB5', '#EADE71', '#6454EC'  ],
    previews: [
        ['https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615907626/hp2021/banners/tab_1/First_Slider_3x.png', 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615907625/hp2021/banners/tab_1/Second_Slider_3x.png', 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615907625/hp2021/banners/tab_1/Third_Slider_3x.png', 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615907625/hp2021/banners/tab_1/Fourth_Slider_3x.png' ], 
        ['https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1616139139/hp2021/banners/tab_2/Group_20603_3x.png', 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1616139139/hp2021/banners/tab_2/Group_20604_3x.png', 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1616139140/hp2021/banners/tab_2/Group_20605_3x.png', 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1616576805/hp2021/banners/tab_2/Group_20747_3x.png' ], 
        ['https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615567189/hp2021/banners/tab_3/sidebar_image_3x.png', 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615567189/hp2021/banners/tab_3/sidebar_image1_3x.png', 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615567190/hp2021/banners/tab_3/sidebar_image2_3x.png', 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1616577364/hp2021/banners/tab_3/Group_20754_3x.png' ],
        ['https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615567668/hp2021/banners/tab_4/sidebar_image_3x.png', 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615567668/hp2021/banners/tab_4/sidebar_image1_3x.png', 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615567669/hp2021/banners/tab_4/sidebar_image2_3x.png', 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615567667/hp2021/banners/tab_4/main_image.png' ], 
        ['https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615907867/hp2021/banners/tab_5/First_Slide_3x.png', 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615907866/hp2021/banners/tab_5/Second_Slide_3x.png', 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615907866/hp2021/banners/tab_5/Third_Slide_3x.png', 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615907866/hp2021/banners/tab_5/Fourth_Slide_3x.png' ], 
        ['https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615908119/hp2021/banners/tab_6/First_Slide_3x.png', 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615908119/hp2021/banners/tab_6/Second_Slide_3x.png', 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615908119/hp2021/banners/tab_6/Third_Slide_3x.png', 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615908119/hp2021/banners/tab_6/Fourth_Slide_3x.png' ],
        ['https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615908399/hp2021/banners/tab_7/First_Slide_3x.png', 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615908399/hp2021/banners/tab_7/Second_Slide_3x.png', 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615908399/hp2021/banners/tab_7/Thirds_Slide_3x.png', 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615908399/hp2021/banners/tab_7/Fourth_Slide_3x.png' ], 
        ['https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1616419182/hp2021/banners/tab_8/Group_20092_3x.png', 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1616419181/hp2021/banners/tab_8/Group_935_3x.png', 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1616419182/hp2021/banners/tab_8/Group_937_3x.png', 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1616419181/hp2021/banners/tab_8/Group_-1_3x.png' ]
    ],
    activeIndex: 0,
    titlePosition: [0, 0]
};

const state = remx.state(initialState);

//#####################################
// getters
// The warpped getters functions shoud be defined inside the same store file and should be exported.
//#####################################

export const getters = remx.getters({
    getTime() {
        return state.time;
    },
    getDelay() {
        return state.delay;
    },
    getValues() {
        return state.values;
    },
    getTabs() {
        return state.tabs;
    },
    getColors() {
        return state.colors;
    },
    getPreviews() {
        return state.previews;
    },
    getActiveIndex() {
        return state.activeIndex;
    },
    getActiveIndex() {
        return state.activeIndex;
    },
    getTitlePosition() {
        return state.titlePosition;
    }
});

//#####################################
// setters
// The warpped setters functions shoud be defined inside the store and should be exported.
//#####################################
export const setters = remx.setters({
    setActiveIndex(value) {
        state.activeIndex = value;
    },
    setTitlePosition(value) {
        state.titlePosition = value;
    }
});